import { requiresAuth, requiresTerms } from "@/middleware";

const HelpView = () => import("./HelpView.vue");

const helpRoutes = [
  {
    path: "/help",
    name: "Help",
    component: HelpView,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  }
];

export default helpRoutes;
